/** @jsxImportSource @emotion/react */
import Footer from 'apollo-react/components/Footer'
import IDSThemeProvider from 'apollo-react/utils/IDSThemeProvider'

export const IDSFooterEmbed = ({
  productInfo,
  TenantZero,
  supportLink,
  termsOfUseLink,
}) => {
  return (
    <IDSThemeProvider themeName="IDS">
      <Footer
        css={{
          a: { color: '#0557d5 !important', fontWeight: '650' },
          'a:visited': { color: '#0557d5 !important', fontWeight: '650' },
        }}
        buttonProps={[
          {
            label: 'Version ' + productInfo,
            href: `${TenantZero}/r/release_notes`,
            target: '_blank',
          },
          {
            label: 'Support',
            href: supportLink,
            target: '_blank',
          },
          {
            label: 'Terms of Use',
            href: termsOfUseLink,
            target: '_blank',
          },
          {
            label: 'Privacy',
            href: 'https://static.clintech.iqvia.com/privacy/',
            target: '_blank',
          },
        ]}
      />
    </IDSThemeProvider>
  )
}

export default IDSFooterEmbed
